export default "__VITE_ASSET__C43YUfWo__"